<template><div><h1>VUX V2.1.1Rc.5 released</h1>
<h2><a href="/en/components/inline-calendar.html">InlineCalendar</a></h2>
<ul><li>[fix] fix render-function not reactive</li>
</ul>
<h2><a href="/en/components/md5.html">Md5</a></h2>
<ul><li>[feature] Fix import and module.exports issue #1007 @zack24q</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.1.1Rc.5 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.1.1-rc.5-84.vue?e3d3c4fc